import useScrollPosition from "../hooks/useScrollPosition"
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ScrollPlaceholder = () => {
    const scrollPosition = useScrollPosition();
    const location = useLocation();
    const url = location.pathname;
    const { isPoolOpen } = useSelector(state => state.searchbar);
    return (
        <div>
            {scrollPosition > 300 && url === "/" && <div className="h-[56px] md:h-[68px]"></div>}
            {scrollPosition > 300 && url === "/all-activities" && isPoolOpen && <div className="h-[372px] md:hidden"></div>}
            {scrollPosition < 300 && <div className="h-0"></div>}
        </div>
    )
}

export default ScrollPlaceholder